import React from "react"

import Newsletter from "./Newsletter"

import {
  FooterSection,
  FooterContainer,
  FooterFormContainer,
  FooterListContainer,
  FooterListHeading,
  FooterList,
  FooterListGroup,
  FooterListItem,
  FooterExternalLink,
  FooterInternalLink,
  FooterBottomContainer,
} from "./FooterElements"

const Footer = () => {
  return (
    <FooterSection>
      <FooterContainer>
        <FooterFormContainer>
          <Newsletter
            heading={"What you don't know can hurt you."}
            body={
              "Stay on top of digital marketing trends with our short but potent marketing email brief."
            }
          />
        </FooterFormContainer>
        <FooterListContainer>
          <FooterListHeading>Contact</FooterListHeading>
          <FooterList>
            <FooterListItem>
              <FooterExternalLink
                href="https://www.facebook.com/StoryDigitalCanada/"
                target="_blank"
                rel="noreferrer"
              >
                Facebook
              </FooterExternalLink>
            </FooterListItem>
            <FooterListItem style={{ marginBottom: "2rem" }}>
              <FooterExternalLink
                href="https://www.linkedin.com/company/story-digital-marketing"
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </FooterExternalLink>
            </FooterListItem>

            <FooterListItem>
              <FooterExternalLink href="tel:6133286780">
                (613) 328-6780
              </FooterExternalLink>
            </FooterListItem>
            <FooterListItem style={{ marginBottom: "2rem" }}>
              {" "}
              <FooterExternalLink href="mailto:hello@storydigital.ca">
                hello@storydigital.ca
              </FooterExternalLink>
            </FooterListItem>

            <FooterListItem>
              <FooterInternalLink to="/privacy-policy">
                Privacy Policy
              </FooterInternalLink>
            </FooterListItem>
          </FooterList>
        </FooterListContainer>
        <FooterBottomContainer>
          <div>
            <FooterListHeading>Industries</FooterListHeading>
            <FooterList>
              <FooterListItem>
                <FooterInternalLink to="/industries/agriculture">
                  Agriculture
                </FooterInternalLink>
              </FooterListItem>
              <FooterListItem>
                <FooterInternalLink to="/industries/non-profit">
                  Non-profit
                </FooterInternalLink>
              </FooterListItem>
            </FooterList>
          </div>
          <div>
            <FooterListHeading>Services</FooterListHeading>
            <FooterList>
              <FooterListItem>
                <FooterInternalLink to="/services/web-design">
                  Web design & development
                </FooterInternalLink>
              </FooterListItem>
              <FooterListItem>
                <FooterInternalLink to="/services/marketing-analysis">
                  Marketing Analysis
                </FooterInternalLink>
              </FooterListItem>
              <FooterListItem>
                <FooterInternalLink to="/services/seo">
                  Search Engine Optimization (SEO)
                </FooterInternalLink>
              </FooterListItem>
              <FooterListItem></FooterListItem>
            </FooterList>
          </div>
        </FooterBottomContainer>
      </FooterContainer>
    </FooterSection>
  )
}

export default Footer
